import React from 'react'
import './style.scss'

const Index = ({stepProgress, renderUploadProgress}) => {
    return(
        <div className="new-channel-steps-container">
            <div className="progress" style={{ display: stepProgress > 0 ? 'flex': 'flex'}}>
                <div className="progress-bar" role="progressbar" style={{width: renderUploadProgress() + '%'}} aria-valuenow="5" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div className="upload-step left">
                <div className={`step-circle ${stepProgress === 0 || stepProgress > 0 ? 'active':'inactive'}`}>
                    <span className="step-num">1</span>
                </div>
                <label className={`step-title ${stepProgress === 0 || stepProgress > 0 ? 'active':'inactive'}`}>Velg type</label>
            </div>
            <div className="upload-step middle">
                <div className={`step-circle ${stepProgress === 1 || stepProgress > 1 ? 'active':'inactive'}`}>
                    <span className="step-num">2</span>
                </div>
                <label className={`step-title ${stepProgress === 1 || stepProgress > 1 ? 'active':'inactive'}`}>Konfigurer</label>
            </div>
            <div className="upload-step right">
                <div className={`step-circle ${stepProgress === 2 ? 'active':'inactive'}`}>
                    <span className="step-num">3</span>
                </div>
                <label className={`step-title ${stepProgress === 2 ? 'active':'inactive'}`}>Fullfør</label>
            </div>
        </div>
    )
}

export default Index